<template>
    <b-card>
        <div class="user-avatar-section">
            <div class="d-flex align-items-center flex-column">
                <div class="avatar bg-light-primary avatar-xl mt-1 mb-2">
                    <span class="avatar-content">CF</span>
                </div>
                <div class="user-info text-center">
                    <h4>{{ user.full_name }}</h4>
                    <span class="badge bg-light-success">{{role}}</span>
                </div>
            </div>
        </div>
        <div class="row my-1">
            <div class="col-6 d-flex align-items-start me-2">
                <span class="badge bg-light-primary p-75 rounded">
                    <vue-feather type="hash" />
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ identityIQ }}</h4>
                    <small>Total Credit Pulls</small>
                </div>
            </div>
            <div class="col-6 d-flex align-items-start">
                <span class="badge bg-light-primary p-75 rounded">
                    <vue-feather type="layers" />
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ lettersCount }}</h4>
                    <small>Total Dispute Letters</small>
                </div>
            </div>
            <div class="col-6 d-flex align-items-start">
                <span class="badge bg-light-primary p-75 rounded">
                    <vue-feather type="users" />
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ user.client_count }}</h4>
                    <small>Total Clients</small>
                </div>
            </div>
            <div class="col-6 d-flex align-items-start">
                <span class="badge bg-light-primary p-75 rounded">
                    <vue-feather type="shield" />
                </span>
                <div class="" style="margin-left: 0.75rem!important">
                    <h4 class="mb-0">{{ user.signed_contracts_count }}</h4>
                    <small>Total Signed Contracts</small>
                </div>
            </div>
        </div>
        <h4 class="fw-bolder border-bottom pb-50 mb-1">Details</h4>
        <div class="info-container">
            <ul class="list-unstyled">
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Fullname: </span>
                    <span>{{user.full_name}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Billing Email: </span>
                    <span>{{user.email}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Plan Status: </span>
                    <span class="badge bg-light-success" v-if="user.my_plan !== null">{{user.my_plan=="null"?'No Active Plan':user.my_plan}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Credit Report Type: </span>
                    <span>{{ user.credit_report_type }}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Contact: </span>
                    <span>{{user.phone}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Address: </span>
                    <span>{{user.address}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">State: </span>
                    <span>{{user.state}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">City: </span>
                    <span>{{user.city}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bolder" style="margin-right: 0.25rem !important;font-weight:bolder;">Balance: </span>
                    <span>{{user.balance}}</span>
                </li>
            </ul>
            <div class="d-flex justify-content-center pt-2">
                <a href="javascript:;" class="btn btn-primary waves-effect waves-float waves-light" style="margin-right: 1rem !important;" v-on:click="openModal('#editUser')">
                    Edit User Role
                </a>
                <a href="javascript:void(0)" class="btn btn-outline-danger suspend-user waves-effect" data-target="#deactivateAccount" data-toggle="modal">Deactivate user Account</a>
            </div>
        </div>
    </b-card>
    <b-card>
        <h6 class="font-primary md-2 fw-bolder" style="margin-bottom: 1rem !important">Credit Monitoring Service Information</h6>
        <ul class="list-unstyled">
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Firstname: </span>
                <span>{{user.firstname}}</span>
            </li>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Middlename: </span>
                <span>{{user.middle_name}}</span>
            </li>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Lastname: </span>
                <span>{{user.lastname}}</span>
            </li>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Active Credit Monitoring Agencies: </span>
                <span>{{ reportStore.creditMonitoringAgencies[user.default_credit_monitoring_agency]?.name }}</span>
            </li>
            <template v-if="user.default_credit_monitoring_agency == reportStore.smartcredit" >
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Smartcredit Email: </span>
                    <span>{{ user.sc_username }}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Smartcredit Password: </span>
                    <span>{{ user.sc_password }}</span>
                </li>
            </template>
            <template v-else-if="user.default_credit_monitoring_agency == reportStore.myfreescorenow" >
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">My Free Score Now Email: </span>
                    <span>{{ user.mfsn_username }}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">My Free Score Now Password: </span>
                    <span>{{ user.mfsn_password }}</span>
                </li>
            </template>
            <template v-else-if="user.default_credit_monitoring_agency == reportStore.identityiq" >
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">IdentityIQ Name: </span>
                    <span>{{ user.iqusername }}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">IdentityIQ Password: </span>
                    <span>{{ user.iqpassword }}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">IdentityIQ Security Answer: </span>
                    <span>{{ user.iq_security_answer }}</span>
                </li>
            </template>
            <template v-else-if="user.default_credit_monitoring_agency == reportStore.myscoreiq" >
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Myscoreiq Name: </span>
                    <span>{{user.myscoreiq_username}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Myscoreiq Password: </span>
                    <span>{{user.myscoreiq_password}}</span>
                </li>
                <li class="mb-75">
                    <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Myscoreiq Security Answer: </span>
                    <span>{{ user.myscoreiq_security_answer }}</span>
                </li>
            </template>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Credit Report Type: </span>
                <span>{{ user.credit_report_type }}</span>
            </li>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Ssn: </span>
                <span>{{user.ssn}}</span>
            </li>
            <li class="mb-75">
                <span class="fw-bold" style="margin-right: 0.25rem !important;font-weight:bolder;">Role: </span>
                <span>{{role}}</span>
            </li>
        </ul>
    </b-card>
    <div class="modal fade" id="editUser" tabindex="-1" aria-modal="true">
        <div class="modal-dialog modal-sm modal-dialog-centered modal-edit-user">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body pb-5 px-sm-5 pt-50">
                    <div class="text-center mb-2">
                        <h1 class="mb-1">Edit User</h1>
                        <form class="form-validate">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="role">Role</label>
                                        <select class="form-control" id="role" name="role" v-model="selectedOption">
                                            <option :value="role.id" v-for="(role,index) in allRoles" :key="index">
                                                {{role.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-12 d-flex flex-sm-row flex-column mt-2">
                                    <button
                                        type="button"
                                        class="btn btn-primary mb-1 mb-sm-0 mr-0 mr-sm-1 waves-effect waves-float waves-light"
                                        v-on:click="updateUserRole()"
                                    >Save Changes</button>
                                    <a
                                        type="button"
                                        href="#"
                                        class="btn btn-outline-secondary d-none d-sm-block waves-effect"
                                        v-on:click="showEditModal"
                                    >Cancel</a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <profile-modal />
    <deactivate-user-account></deactivate-user-account>
</template>
<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue-3'
import vSelect from 'vue-select'
import axios from 'axios'
import DeactivateUserAccount from './DeactivateUserAccount.vue'
import { useReportStore } from '../../../../stores/ReportStore'
import { useUserStore } from '../../../../stores/UserStore'
import Profile from '../../../modals/Profile'
// import 'vue-select/dist/vue-select.css';
import {openModal,hideModal, closeModal} from '../../../../utilities/_helpers'
export default{
    components: {
        BCard,
        BButton,
        BRow,
        BCol,
        BAvatar,
        vSelect,
        DeactivateUserAccount,
        'profile-modal': Profile
    },
  data(){
    return{
      user:{},
      role:"",
      lettersCount:"",
      identityIQ:"",
      deleteShow:false,
      showEditUser:false,
      userRole:'',
      category: ['credit', 'creditfix', 'report'],
      selectedOption:'',
      allRoles:[],
      firstname:'',
      lastname:'',
      middlename:'',
    }
  },
  setup(){
    return {
        reportStore: useReportStore(),
        userStore: useUserStore(),
        hideModal: hideModal,
        openModal: openModal
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  created() {
      this.getUserLists();
      this.userStore.fetchStates()
  },
  methods: {
      showEditModal(){
        if(this.showEditUser == true){
          this.showEditUser=false
        }else{
          this.showEditUser=true
        }
      },
      async getUserLists(){
        const route = this.$router.resolve(
            {
                name: 'user-show',
                params: {
                    user: this.$route.params.user
                }
            }
        );
        let status ={
          status:0
        }
        axios.post(route.href,status).then(({data})=>{
          this.user = data.data.user
          this.role = data.data.userRole
          this.lettersCount= data.data.lettersCount,
          this.identityIQ = data.data.identityIQ
          this.allRoles=data.data.allroles
          this.userRole = data.data.user.roles[0]
          this.selectedOption=data.data.user.roles[0].id
          this.firstname = data.data.user.firstname
          this.lastname = data.data.user.middle_name
          this.middlename = data.data.user.lastname
          this.userStore.adminUserview = this.user
          this.userStore.roles = data.data.allroles
          this.userStore.deactivateId = this.user.id
        }).catch();

      },
      updateUserRole(){
        if(this.selectedOption != ""){
            let data = {
                'role':this.selectedOption
            }
            const route = this.$router.resolve(
            {
                name: 'create-user',
                params: {
                    user: this.$route.params.user
                }
            }
            );
            axios.put(route.href,data).then(({data})=>{
                toastr.success(data.message,'Update Notification!');
                this.showEditUser=false
                setTimeout(()=>{
                    window.location.reload()
                },3000);
            }).catch();
        }
      },
      showEditModal(){
        this.userStore.showEditUser = true;
      }

  },
}
</script>
